import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ESIGN_GET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetEsignRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = ESIGN_GET_URL;

  constructor(applicationId, sendToStaffEmail, esignDocsUploaded) {
    super();

    const paramList = [
      applicationId,
      sendToStaffEmail ? sendToStaffEmail : "",
      esignDocsUploaded ? esignDocsUploaded : "",
    ];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
